// extracted by mini-css-extract-plugin
module.exports = {"newCanvasButtonContent":"NewCanvasButton_newCanvasButtonContent__SoVzM"};